<template>
  <machinery-form
    :hasWritePerm="hasWritePerm"
    :visible="editMachineryDialog"
    :machinery="selectedMachineryForm"
    :officeId="officeId"
    :dialogTitle="'hfManagement.machineryPerformance.editMachinaryDialogTitle'"
    :initFormValid="true"
    :isEditMode="true"
    @close="closeEditMachineryFormDialog"
    @savemachinery="updateMachinery"
    @deletemachinery="deleteMachinery"
  />
</template>

<script>
import HFMachineryForm from "./HFMachineryForm";
import findIndex from "lodash/findIndex";

export default {
  components: {
    MachineryForm: HFMachineryForm
  },
  props: {
    hasWritePerm: {
      type: Boolean,
      required: true
    },
    officeId: {
      type: String,
      required: true
    },
    editMachineryDialog: {
      type: Boolean,
      required: true
    },
    selectedMachineryId: {
      type: String,
      required: true
    }
  },
  watch: {
    editMachineryDialog: {
      handler: function () {
        if (this.editMachineryDialog) {
          this.$store.commit("machinery/RESET_MACHINERY_FORM");
          this.$store.commit(
            "machinery/SET_SELECTED_MACHINERY_FORM",
            this.selectedMachineryId
          );
          this.initialMachineryForm =
            this.$store.getters["machinery/initialMachineryForm"];
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      initialMachineryForm: {}
    };
  },
  created() {},
  methods: {
    closeEditMachineryFormDialog() {
      this.$emit("closeeditmachineryformdialog");
      this.$store.commit("machinery/RESET_MACHINERY_FORM");
      this.$store.dispatch("machinery/fetchOfficeEquipment", this.officeId);
    },
    updateMachinery() {
      this.$store
        .dispatch("machinery/updateMachinery", this.officeId)
        .then(() => {
          return this.deleteMachineryServices();
        })
        .then(() => {
          return this.allAddServicePromises();
        })
        .then(() => {
          this.closeEditMachineryFormDialog();
        })
        .then(() => {
          this.$store.dispatch("machinery/fetchOfficeEquipment", this.officeId);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {});
    },
    async deleteMachineryServices() {
      let _this = this;
      let servicesToDelete =
        _this.$store.getters["machinery/getServicesToDelete"];
      await servicesToDelete.forEach(serviceId => {
        _this.$store.dispatch("machinery/deleteMachineryService", {
          machineryService: {
            machineryId: _this.selectedMachineryId,
            serviceId: serviceId
          }
        });
      });
    },
    allAddServicePromises() {
      return Promise.all(
        this.selectedMachineryForm.serviceList.map(
          this.singleAddServicePromise()
        )
      );
    },
    singleAddServicePromise() {
      return service => {
        if (
          findIndex(this.initialMachineryForm.serviceList, {
            serviceId: service.serviceId
          }) === -1
        ) {
          return new Promise((resolve, reject) => {
            return this.$store
              .dispatch("machinery/addMachineryService", {
                machineryService: {
                  machineryId: this.selectedMachineryId,
                  serviceId: service.serviceId
                }
              })
              .then(() => {
                resolve();
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };
    },
    deleteAllServicesBeforeDeleteMachinery() {
      const deleteService = () => {
        return service => {
          return new Promise((resolve, reject) => {
            return this.$store
              .dispatch("machinery/deleteMachineryService", {
                machineryService: {
                  machineryId: this.selectedMachineryId,
                  serviceId: service.serviceId
                }
              })
              .then(() => {
                resolve();
              })
              .catch(error => {
                reject(error);
              });
          });
        };
      };

      return Promise.all(
        this.initialMachineryForm.serviceList.map(deleteService())
      );
    },
    deleteMachinery() {
      this.deleteAllServicesBeforeDeleteMachinery()
        .then(() => {
          this.$store.dispatch(
            "machinery/deleteMachinery",
            this.selectedMachineryId
          );
        })
        .then(() => {
          this.closeEditMachineryFormDialog();
        })
        .then(() => {
          this.$store.dispatch("machinery/fetchOfficeEquipment", this.officeId);
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {});
    }
  },
  computed: {
    selectedMachineryForm() {
      return this.$store.getters["machinery/machineryForm"];
    },
    isMachineryNameUpdated() {
      return this.selectedMachineryForm.name !== this.initialMachineryForm.name;
    }
  }
};
</script>
